import type { QueryKey } from "@tanstack/react-query";

/**
 * placeholderData for a paginated list that belongs to one record (a portfolio,
 * a promo code, a course): while another page loads, keep the rows on screen
 * instead of an empty list or spinner, but only while the record stays the same,
 * so another record's rows never show. Lists without an owner use TanStack's
 * `keepPreviousData`.
 */
export const keepPreviousPageOf =
  (owner: string | undefined) =>
  <T>(previous: T | undefined, previousQuery?: { queryKey: QueryKey }) =>
    owner && previousQuery?.queryKey.includes(owner) ? previous : undefined;
